import React, { useState } from 'react'
import { SEARCH_CONFIG } from '../../../config/saerchConfig'
import clsx from 'clsx'
import styles from './styles.module.scss'

export const SearchBar = () => {
    const [text, setText] = useState('')

    return (
        <div className={clsx(styles.searchBar, 'searchBar')}>
            <form
                className={styles.form}
                onSubmit={(e) => {
                    e.preventDefault()

                    window.location.href = `${SEARCH_CONFIG.pathSegment}/?${
                        SEARCH_CONFIG.queryKey
                    }=${encodeURIComponent(text.trim())}`
                }}
            >
                <input
                    required
                    className={styles.input}
                    placeholder="Recherchez une info, un article, un document..."
                    type="text"
                    value={text}
                    onChange={(e) => {
                        setText(e.target.value)
                    }}
                    autoFocus
                />
                <span className={styles.inputBorder} />
                <button type="submit" title="Rechercher" className={styles.button}>
                    <i className="fi fi-rs-arrow-right" />
                </button>
            </form>
        </div>
    )
}
